var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.coLoader
    ? _c(
        "div",
        {
          staticClass: "ma-0 pa-0 conversation",
          attrs: { id: "conversation-header" }
        },
        [
          _vm.coTitle
            ? _c(
                "v-layout",
                { staticClass: "pr-3 conversation__header" },
                [
                  _c(
                    "v-layout",
                    { staticClass: "message-content", attrs: { column: "" } },
                    [
                      _c(
                        "v-layout",
                        { staticClass: "primary--text" },
                        [
                          _c("h2", {
                            staticClass: "mr-1",
                            class: _vm.coTitle ? "message-content--after" : "",
                            staticStyle: { "font-weight": "900" },
                            domProps: { textContent: _vm._s(_vm.coTitle) }
                          }),
                          _vm._v(" "),
                          _c("h2", {
                            staticClass: "mr-1",
                            staticStyle: { "font-weight": "500" },
                            domProps: { textContent: _vm._s(_vm.coBlockName) }
                          }),
                          _vm._v(" "),
                          _vm.coOrderApartment.length > 0
                            ? [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "" },
                                    model: {
                                      value: _vm.dtShowApartment,
                                      callback: function($$v) {
                                        _vm.dtShowApartment = $$v
                                      },
                                      expression: "dtShowApartment"
                                    }
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        attrs: { slot: "activator" },
                                        slot: "activator"
                                      },
                                      [
                                        _c("h2", {
                                          staticClass: "mr-1",
                                          attrs: { name: "apartment-fullname" },
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.coApartmentName
                                            )
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.dtShowApartment = !_vm.dtShowApartment
                                            }
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      { attrs: { column: "" } },
                                      _vm._l(_vm.coOrderApartment, function(
                                        m,
                                        index
                                      ) {
                                        return _c("span", { key: m.id }, [
                                          _vm._v(_vm._s(m.text))
                                        ])
                                      })
                                    )
                                  ],
                                  1
                                )
                              ]
                            : [
                                _c("h2", {
                                  staticClass: "mr-1",
                                  attrs: { name: "apartment-fullname" },
                                  domProps: {
                                    textContent: _vm._s(_vm.coApartmentName)
                                  }
                                })
                              ],
                          _vm._v(" "),
                          _vm.coOrderZones.length > 0
                            ? [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { right: "" },
                                    model: {
                                      value: _vm.dtShowZones,
                                      callback: function($$v) {
                                        _vm.dtShowZones = $$v
                                      },
                                      expression: "dtShowZones"
                                    }
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        attrs: { slot: "activator" },
                                        slot: "activator"
                                      },
                                      [
                                        _c("h2", {
                                          staticStyle: { "font-weight": "400" },
                                          domProps: {
                                            textContent: _vm._s(_vm.coZones)
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.dtShowZones = !_vm.dtShowZones
                                            }
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      { attrs: { column: "" } },
                                      _vm._l(_vm.coOrderZones, function(
                                        z,
                                        index
                                      ) {
                                        return _c("span", { key: z.id }, [
                                          _vm._v(_vm._s(z.text))
                                        ])
                                      })
                                    )
                                  ],
                                  1
                                )
                              ]
                            : [
                                _c("h2", {
                                  staticStyle: { "font-weight": "400" },
                                  domProps: { textContent: _vm._s(_vm.coZones) }
                                })
                              ]
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        {
                          staticClass: "primary--text  mb-2",
                          staticStyle: {
                            "margin-left": "-7px",
                            "margin-top": "2px"
                          },
                          attrs: { column: "" }
                        },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", "pl-1": "" } },
                            [
                              _c("v-layout", [
                                _vm.coProblemTypology.level_1
                                  ? _c("div", { staticClass: "pr-2" }, [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              _vm.lblSetting.ticketTypeOfProblem
                                            ) + " 1"
                                          )
                                        )
                                      ]),
                                      _vm._v(" :\n              "),
                                      _c("b", [
                                        _c(
                                          "i",
                                          {
                                            attrs: { name: "manager-fullname" }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.coProblemTypology.level_1
                                              )
                                            )
                                          ]
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.coProblemTypology.level_2
                                  ? _c("div", { staticClass: "pr-2" }, [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              _vm.lblSetting.ticketTypeOfProblem
                                            ) + " 2"
                                          )
                                        )
                                      ]),
                                      _vm._v(" :\n              "),
                                      _c("b", [
                                        _c(
                                          "i",
                                          {
                                            attrs: { name: "manager-fullname" }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.coProblemTypology.level_2
                                              )
                                            )
                                          ]
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.coTicketSubstatus.haveSubstatus
                                  ? _c("div", { staticClass: "pr-2" }, [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            "" +
                                              _vm.$t(
                                                _vm.lblSetting.ticketSubstatus
                                              )
                                          )
                                        )
                                      ]),
                                      _vm._v(" :\n              "),
                                      _c("b", [
                                        _c(
                                          "i",
                                          {
                                            attrs: { name: "manager-fullname" }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.coTicketSubstatus.name)
                                            )
                                          ]
                                        )
                                      ])
                                    ])
                                  : _vm._e()
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", "pl-1": "" } },
                            [
                              _c("v-layout", [
                                _vm.ticket.ticket_availability_mileage &&
                                _vm.ticket.ticket_availability_mileage.mileage
                                  ? _c("div", { staticClass: "pr-2" }, [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            "" +
                                              _vm.$t(
                                                _vm.lblSetting
                                                  .ticketVehicleMileage
                                              )
                                          )
                                        )
                                      ]),
                                      _vm._v(" :\n              "),
                                      _c("b", [
                                        _c(
                                          "i",
                                          {
                                            attrs: { name: "manager-fullname" }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.ticket
                                                  .ticket_availability_mileage
                                                  .mileage
                                              )
                                            )
                                          ]
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.ticket.ticket_availability_mileage &&
                                _vm.ticket.ticket_availability_mileage
                                  .availability
                                  ? _c("div", { staticClass: "pr-2" }, [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            "" +
                                              _vm.$t(
                                                _vm.lblSetting
                                                  .ticketVehicleAvailability
                                              )
                                          )
                                        )
                                      ]),
                                      _vm._v(" :\n              "),
                                      _c("b", [
                                        _c(
                                          "i",
                                          {
                                            attrs: { name: "manager-fullname" }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.ticket
                                                  .ticket_availability_mileage
                                                  .availability
                                              )
                                            )
                                          ]
                                        )
                                      ])
                                    ])
                                  : _vm._e()
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { staticClass: "primary--text" },
                        [
                          _c("span", {
                            staticClass: "message-content__code",
                            domProps: { textContent: _vm._s(_vm.coTicketCode) }
                          }),
                          _vm._v(" "),
                          _c("i", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(_vm.lblSetting.ticketCreator, {
                                  date: _vm.coCreatedDate,
                                  name: _vm.coFullNameDeclarant
                                })
                              )
                            }
                          }),
                          _vm._v("\n        , \n        "),
                          _vm.coOrderMangers.length > 0
                            ? [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "" },
                                    model: {
                                      value: _vm.dtShowManager,
                                      callback: function($$v) {
                                        _vm.dtShowManager = $$v
                                      },
                                      expression: "dtShowManager"
                                    }
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        attrs: { slot: "activator" },
                                        slot: "activator"
                                      },
                                      [
                                        _c("i", {
                                          attrs: { name: "manager-fullname" },
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.$t(
                                                _vm.lblSetting
                                                  .ticketAssignedMore,
                                                {
                                                  name: _vm.coFullNameManager,
                                                  numberOfManager:
                                                    _vm.coOrderMangers.length
                                                }
                                              )
                                            )
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.dtShowManager = !_vm.dtShowManager
                                            }
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      { attrs: { column: "" } },
                                      _vm._l(_vm.coOrderMangers, function(
                                        m,
                                        index
                                      ) {
                                        return _c("span", { key: m.id }, [
                                          _vm._v(_vm._s(m.text))
                                        ])
                                      })
                                    )
                                  ],
                                  1
                                )
                              ]
                            : [
                                _c("i", {
                                  attrs: { name: "manager-fullname" },
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t(_vm.lblSetting.ticketAssigned, {
                                        name: _vm.coFullNameManager
                                      })
                                    )
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.dtShowManager = !_vm.dtShowManager
                                    }
                                  }
                                })
                              ],
                          _vm._v(" "),
                          _vm.$route.meta.select_ticket_priority
                            ? _c(
                                "span",
                                { staticClass: "message-content__code" },
                                [
                                  _vm._v("\n          , \n        "),
                                  _c("i", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          _vm.lblSetting.ticketPriorityLevel
                                        )
                                      )
                                    }
                                  }),
                                  _vm._v(" : \n        "),
                                  _c(
                                    "i",
                                    {
                                      class:
                                        "priority--" +
                                        _vm.coTicketPriorityLevel.key
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.coTicketPriorityLevel.name)
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-menu",
                    {
                      staticClass: "pr-2",
                      attrs: {
                        "offset-y": "",
                        bottom: "",
                        transition: "slide-x-transition",
                        "nudge-width": 350,
                        "close-on-content-click": false,
                        "content-class": "menu-content__ticket"
                      },
                      model: {
                        value: _vm.dtActionOpen,
                        callback: function($$v) {
                          _vm.dtActionOpen = $$v
                        },
                        expression: "dtActionOpen"
                      }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-0",
                          attrs: {
                            slot: "activator",
                            fab: "",
                            dark: "",
                            small: "",
                            color: _vm.dtActionOpen ? "secondary" : "primary"
                          },
                          slot: "activator"
                        },
                        [
                          _c("v-icon", { attrs: { dark: "" } }, [
                            _vm._v("more_horiz")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "v-expansion-panel",
                            {
                              staticStyle: { "box-shadow": "none !important" },
                              attrs: { expand: "" },
                              model: {
                                value: _vm.dtExpandedValues,
                                callback: function($$v) {
                                  _vm.dtExpandedValues = $$v
                                },
                                expression: "dtExpandedValues"
                              }
                            },
                            _vm._l(_vm.coTeams, function(team, index) {
                              return _c(
                                "v-expansion-panel-content",
                                {
                                  key: "team-" + index,
                                  staticStyle: {
                                    border: "none",
                                    padding: "0 !important"
                                  }
                                },
                                [
                                  _c(
                                    "template",
                                    { slot: "actions" },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "primary" } },
                                        [_vm._v("$vuetify.icons.expand")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: { padding: "0 !important" },
                                      attrs: { slot: "header" },
                                      slot: "header"
                                    },
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            "align-center": "",
                                            "justify-start": "",
                                            row: ""
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "mr-3",
                                              staticStyle: { width: "35px" },
                                              attrs: { color: "primary" }
                                            },
                                            [_vm._v(_vm._s(team.icon))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "primary--text" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(team.translationKey)
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticStyle: {
                                          width: "90%",
                                          margin: "10px auto 0 50px",
                                          height: "1px",
                                          "background-color": "#f92ac2"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  !_vm.closeVisibility(team.key) &&
                                  !_vm.attachmentVisibility(team.key) &&
                                  !_vm.apartmentsVisibility(team.key) &&
                                  !_vm.equipmentsVisibility(team.key) &&
                                  !_vm.zonesVisibility(team.key)
                                    ? _c(
                                        "v-list",
                                        { staticClass: "ml-5 mr-2" },
                                        _vm._l(team.records, function(
                                          record,
                                          sIndex
                                        ) {
                                          return _c(
                                            "v-list-tile",
                                            {
                                              key: index + "-" + sIndex,
                                              attrs: { avatar: "" }
                                            },
                                            [
                                              _c(
                                                "v-list-tile-avatar",
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        color: "primary"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(record.icon)
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("v-list-tile-content", [
                                                _c("span", {
                                                  staticClass: "text-item",
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.handleGetObjectName(
                                                        record
                                                      )
                                                    )
                                                  }
                                                })
                                              ]),
                                              _vm._v(" "),
                                              _c("v-spacer"),
                                              _vm._v(" "),
                                              _vm.getVisibility(team, record)
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticStyle: {
                                                        "text-decoration":
                                                          "none"
                                                      },
                                                      attrs: {
                                                        href:
                                                          "javascript:void(0);"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.onBeforeRemove(
                                                            record
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            color: "primary"
                                                          }
                                                        },
                                                        [_vm._v("close")]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        }),
                                        1
                                      )
                                    : _vm.ticket.apartments &&
                                      _vm.apartmentsVisibility(team.key)
                                    ? _c(
                                        "v-list",
                                        { staticClass: "ml-5 mr-2" },
                                        _vm._l(_vm.ticket.apartments, function(
                                          apartment,
                                          sIndex
                                        ) {
                                          return _c(
                                            "v-list-tile",
                                            {
                                              key: index + "-" + sIndex,
                                              attrs: { avatar: "" }
                                            },
                                            [
                                              _c(
                                                "v-list-tile-avatar",
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        color: "primary"
                                                      }
                                                    },
                                                    [_vm._v("icon-blocks")]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("v-list-tile-content", [
                                                _c("span", {
                                                  staticClass: "text-item",
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.apartmentFormatted(
                                                        apartment
                                                      )
                                                    )
                                                  }
                                                })
                                              ])
                                            ],
                                            1
                                          )
                                        }),
                                        1
                                      )
                                    : _vm.ticket.equipments &&
                                      _vm.equipmentsVisibility(team.key)
                                    ? _c(
                                        "v-list",
                                        { staticClass: "ml-5 mr-2" },
                                        _vm._l(_vm.ticket.equipments, function(
                                          equipment,
                                          sIndex
                                        ) {
                                          return _c(
                                            "v-list-tile",
                                            {
                                              key: index + "-" + sIndex,
                                              attrs: {
                                                to: _vm.handelEquipmentLink(
                                                  equipment
                                                ),
                                                avatar: ""
                                              }
                                            },
                                            [
                                              _c(
                                                "v-list-tile-avatar",
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        color: "primary"
                                                      }
                                                    },
                                                    [_vm._v("handyman")]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("v-list-tile-content", [
                                                _c("span", {
                                                  staticClass: "text-item",
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.equipmentFormatted(
                                                        equipment
                                                      )
                                                    )
                                                  }
                                                })
                                              ])
                                            ],
                                            1
                                          )
                                        }),
                                        1
                                      )
                                    : _vm.ticket.apartment_zone &&
                                      _vm.zonesVisibility(team.key)
                                    ? _c(
                                        "v-list",
                                        { staticClass: "ml-5 mr-2" },
                                        _vm._l(
                                          _vm.ticket.apartment_zone,
                                          function(zone, sIndex) {
                                            return _c(
                                              "v-list-tile",
                                              {
                                                key: index + "-" + sIndex,
                                                attrs: { avatar: "" }
                                              },
                                              [
                                                _c(
                                                  "v-list-tile-avatar",
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          color: "primary"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(team.icon)
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("v-list-tile-content", [
                                                  _c("span", {
                                                    staticClass: "text-item",
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.zoneFormatted(zone)
                                                      )
                                                    }
                                                  })
                                                ])
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      )
                                    : _vm.attachmentVisibility(team.key)
                                    ? _c(
                                        "v-list",
                                        {
                                          staticClass: "ml-5 mr-2",
                                          staticStyle: {
                                            padding: "0 !important"
                                          }
                                        },
                                        _vm._l(_vm.coAttachments, function(
                                          att,
                                          sindex
                                        ) {
                                          return _c(
                                            "a",
                                            {
                                              key: att.id,
                                              staticClass:
                                                " attachment-item__a",
                                              attrs: {
                                                href:
                                                  att.attachment.media
                                                    .downloadLink ||
                                                  att.attachment.media.link,
                                                target: "_blank"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-list-tile",
                                                {
                                                  staticClass: "attachment-item"
                                                },
                                                [
                                                  _c(
                                                    "v-list-tile-avatar",
                                                    {
                                                      staticStyle: {
                                                        "border-width":
                                                          "1px solid #DDD"
                                                      }
                                                    },
                                                    [
                                                      att.attachment.media
                                                        .type === "image"
                                                        ? _c("img", {
                                                            attrs: {
                                                              src:
                                                                att.attachment
                                                                  .media
                                                                  .downloadLink ||
                                                                att.attachment
                                                                  .media.link
                                                            }
                                                          })
                                                        : _c(
                                                            "v-icon",
                                                            {
                                                              staticStyle: {
                                                                "font-size":
                                                                  "30px",
                                                                "margin-right":
                                                                  "10px"
                                                              },
                                                              attrs: {
                                                                color: "primary"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                      " +
                                                                  _vm._s(
                                                                    att
                                                                      .attachment
                                                                      .media
                                                                      .type ===
                                                                      "video"
                                                                      ? "play_arrow"
                                                                      : "description"
                                                                  ) +
                                                                  "\n                    "
                                                              )
                                                            ]
                                                          )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-list-tile-content",
                                                    [
                                                      _c("v-list-tile-title", {
                                                        staticStyle: {
                                                          color: "#4A4A4A"
                                                        },
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            att.attachment.media
                                                              .name
                                                          )
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-list-tile-sub-title",
                                                        [
                                                          _c("small", {
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                _vm.$t(
                                                                  _vm.lblSetting
                                                                    .ticketUploadedBy,
                                                                  {
                                                                    name: _vm.handleGetObjectName(
                                                                      att.actor
                                                                        .entity
                                                                    ),
                                                                    date: _vm.handleGetCreatedAt(
                                                                      att
                                                                    )
                                                                  }
                                                                )
                                                              )
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        })
                                      )
                                    : _c(
                                        "v-list",
                                        { staticClass: "ml-5 mr-2" },
                                        [
                                          _c(
                                            "v-list-tile",
                                            {
                                              attrs: {
                                                disabled: _vm.coNotClosed
                                              },
                                              on: {
                                                click: _vm.handleReopenTicket
                                              }
                                            },
                                            [
                                              _c(
                                                "v-list-tile-avatar",
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        color: "primary"
                                                      }
                                                    },
                                                    [_vm._v("icon-check")]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("v-list-tile-title", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      _vm.lblSetting
                                                        .ticketReopen
                                                    )
                                                  )
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile",
                                            {
                                              on: {
                                                click: _vm.handleDuplicateTicket
                                              }
                                            },
                                            [
                                              _c(
                                                "v-list-tile-avatar",
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        color: "primary"
                                                      }
                                                    },
                                                    [_vm._v("add_to_photos")]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("v-list-tile-title", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      _vm.lblSetting
                                                        .ticketDuplicate
                                                    )
                                                  )
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                ],
                                2
                              )
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _vm.canUpdateTicket && _vm.ticket.state !== "close"
                            ? _c(
                                "v-list",
                                {
                                  staticStyle: { "padding-top": "0px" },
                                  attrs: { color: "primary" }
                                },
                                [
                                  _c(
                                    "v-list-tile",
                                    {
                                      attrs: {
                                        disabled:
                                          !_vm.canUpdateTicket &&
                                          _vm.ticket.state === "close"
                                      },
                                      on: { click: _vm.handleUpdateTicket }
                                    },
                                    [
                                      _c(
                                        "v-list-tile-avatar",
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "mr-3",
                                              staticStyle: {
                                                width: "35px",
                                                "margin-left": "25px"
                                              },
                                              attrs: { color: "primary" }
                                            },
                                            [_vm._v("edit")]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-content",
                                        {
                                          class: {
                                            disabled: _vm.canUpdateTicket
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "text-item",
                                              staticStyle: { color: "#2E038C" }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.lblSetting.ticketUpdate
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-layout",
            [
              _vm.ticket.createdAt
                ? _c("the-seperator", {
                    class: ["main-seperator", _vm.coCreatedAt],
                    attrs: { date: _vm.coCreatedAt }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "290" },
              model: {
                value: _vm.dtConfirmationVisible,
                callback: function($$v) {
                  _vm.dtConfirmationVisible = $$v
                },
                expression: "dtConfirmationVisible"
              }
            },
            [
              _c(
                "v-card",
                { attrs: { color: "primary" } },
                [
                  _c("v-card-text", {
                    staticClass: "white--text",
                    domProps: { innerHTML: _vm._s(_vm.removeParticipantMsg) }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "white", flat: "" },
                          on: { click: _vm.handleRemoveParticipants }
                        },
                        [_vm._v(_vm._s(_vm.$t("BTN_OK")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "white", flat: "" },
                          on: { click: _vm.onCancel }
                        },
                        [_vm._v(_vm._s(_vm.$t("BTN_CANCEL")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _c("chat-header-loader")
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-92f3f9ee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92f3f9ee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/ticket/components/ticket-chat-header/template.html
// module id = null
// module chunks = 